import React from 'react';
import SectionDivider from './SectionDivider';
import { puckColorField } from '../../../puck/fields/createPuckColorField';
import { puckHorizontalAlignField } from '../../../puck/fields/puckHorizontalAlignField';
import { puckPxSpacingField } from '../../../puck/fields/puckPxSpacingField';
import { DEFAULT_BORDER_COLOR } from '../../../../shared/boxes/borderStyles';
import { puckSectionField } from '../../../puck/fields/puckSectionField';

const sectionDividerConfig = {
  label: 'Séparateur',
  defaultProps: {
    label: '',
    // Même gris que les bordures de box (utils/borderStyles).
    color: DEFAULT_BORDER_COLOR,
    lineStyle: 'solid',
    labelPosition: 'center',
    spacing: '1rem',
  },
  // Le texte au centre s'édite UNIQUEMENT sur le canvas (règle InfoCard).
  fields: {
    _section1: puckSectionField('Style'),
    color: puckColorField('Couleur du trait', { glyph: 'stroke' }),
    lineStyle: {
      type: 'select',
      label: 'Style de ligne',
      options: [
        { label: 'Plein', value: 'solid' },
        { label: 'Tirets', value: 'dashed' },
        { label: 'Pointillés', value: 'dotted' },
      ],
    },
    spacing: puckPxSpacingField('Espace au-dessus et en dessous'),

    _section2: puckSectionField('Affichage'),
    labelPosition: puckHorizontalAlignField('Position du texte'),
  },
  render: (props) => <SectionDivider {...props} />,
};

export default sectionDividerConfig;
